export default __webpack_public_path__ + "static/media/business.cadd2116.svg";